<template>
  <div>
    <section
      v-show="searching"
      class="section"
    >
      <p class="title has-text-centered is-primary">
        Searching far and wide...
      </p>
      <div class="columns is-centered ">
        <div class="message">
          <div class="message-body">
            <div class="content">
              <div>
                <strong>{{ mockCompanyData[mockedDataIndex].name }}
                  ({{ mockCompanyData[mockedDataIndex].ticker }})
                </strong>
                <span :style="`filter: blur(${blur}px); transition: filter 300ms`">
                  -- Match score: 100/100
                  <p>
                    ({{ mockCompanyData[mockedDataIndex].description }})
                  </p>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div
      v-if="error"
      class="columns is-centered"
    >
      <div class="column is-two-thirds">
        <div class="notification is-primary ">
          <p>
            No funds or mix of funds or companies is a really good fit for {{ searchText }}.
          </p>
          <p>
            What we could do is create a totally custom portfolio. Would you like to start that process?
          </p>
          <br>
          <div class="buttons is-centered">
            <a class="button is-small is-primary is-inverted">
              Create Custom Portfolio
            </a>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!searching && !error">
      <div class="buttons is-right">
        <a class="button is-primary is-small">
          <span @click="shareIdeaList">Share Idea List</span>
          <span class="icon"><i class="fas fa-link fa-sm" /></span>
        </a>
      </div>
      <o-tabs
        v-if="!searching"
        v-model="activeTab"
        size="large"
        position="centered"
      >
        <!-- <o-tab-item class="max-width" :value="0" label="Breakdown">
          <pie-chart :chart-data="chartData" :options="chartOptions" ref="pie"></pie-chart>
        </o-tab-item> -->

        <o-tab-item
          :value="1"
          label="All"
        >
          <div v-for="result in results.companies">
            <div class="message is-primary mymessage">
              <div class="message-body">
                <div class="columns">
                  <div class="column">
                    <span class="title is-5">{{ result.name }}</span>
                    <span class="heading is-size-6">{{ result.ticker }}</span>
                  </div>
                  <div class="column is-right">
                    <nav class="level">
                      <div class="level-left">
                        <div class="level-item has-text-centered">
                          <div v-if="result.fundamentals?.MarketCapitalization && result.fundamentals?.MarketCapitalization.trim() != ''">
                            <p class="heading">
                              Market Cap
                            </p>
                            <p> {{ formatDollar(result.fundamentals?.MarketCapitalization) }}</p>
                          </div>
                        </div>
                        <div class="level-item has-text-centered">
                          <div v-if="result.r1yr && result.r1yr.trim() != ''">
                            <p class="heading">
                              1 Year Return
                            </p>
                            <p>{{ formatPercent(result.r1yr) }}</p>
                          </div>
                        </div>
                        <div class="level-item has-text-centered">
                          <div v-if="result.fundamentals?.PERatio && result.fundamentals?.PeRatio?.trim() != ''">
                            <p class="heading">
                              PE Ratio
                            </p>
                            <p>{{ formatPercent(result.fundamentals?.PERatio) }}</p>
                          </div>
                        </div>
                      </div>
                      <!--
                                  <div class="level-item has-text-centered">
                                    <div>
                                            <p class="heading">P/E: {{ result.fundamentals?.PERatio }}</p>
                                            <p class="heading">Forward P/E: {{ result.fundamentals?.ForwardPERatio }}</p>
                                            <p class="heading">P/S: {{ result.fundamentals?.PriceToSalesRatioTTM }}</p>
                                            <p class="heading">Dividend Yield: {{ result.fundamentals?.DividendYield }}</p>
                                            <p class="heading">P/B: {{ result.fundamentals?.PriceToBookRatio }}</p>
                                    </div>
                                </div> -->
                      <div class="level-item has-text-centered">
                        <div>
                          <p class="heading">
                            Match Score
                          </p>
                          <p> {{ result.score }}</p>
                        </div>
                      </div>
                      <div class="level-right">
                        <div class="level-item has-text-right">
                          <div>
                            <a
                              class="button is-primary is-small"
                              :href="'/ai/explore/' + result.ticker + '/?query=' + encodeURIComponent(searchText) + '&reason=' + encodeURIComponent(result.reason || result.explanation)"
                              target="_new"
                            >
                              <span>Share Pick</span>
                              <span class="icon"><i class="fas fa-link fa-sm" /></span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </nav>
                  </div>
                </div>
                <p>
                  <strong>Reason</strong>
                  <br>
                  {{ result.explanation || result.reason }}
                </p>
                <br>
                <p>
                  <strong>Description</strong>
                  <br>
                  {{ result.description }}
                </p>
              </div>
            </div>
            <br>
          </div>
          <div v-for="fund in results.funds">
            <div class="message is-primary mymessage">
              <div class="message-body">
                <div class="columns">
                  <div class="column">
                    <span class="title is-5">{{ fund.name }}</span>
                    <span class="heading is-size-6">{{ fund.fund }}</span>
                  </div>
                  <div class="column is-right">
                    <nav class="level">
                      <div class="level-left">
                        <!-- <div class="level-item has-text-centered">
                                            <div>
                                                <p class="heading">AUM: {{ fund.aum }}</p>
                                                <p class="heading">Expense Ratio: {{ fund.expense_ratio }}</p>
                                                <p class="heading">Front Load: {{ fund.front_load }}</p>
                                                <p class="heading">Back Load: {{ fund.back_load }}</p>
                                                <p class="heading">1 Year Return: {{ fund.r1yr }}</p>
                                            </div>
                                        </div> -->
                        <div class="level-item has-text-centered">
                          <div>
                            <p class="heading">
                              Expense Ratio
                            </p>
                            <p class="help">
                              {{ formatPercent(fund.expense_ratio) }}
                            </p>
                          </div>
                        </div>
                        <div class="level-item has-text-centered">
                          <div>
                            <p class="heading">
                              AUM
                            </p>
                            <p class="help">
                              {{ formatDollar(fund.aum) }}
                            </p>
                          </div>
                        </div>
                        <div class="level-item has-text-centered">
                          <div>
                            <p class="heading">
                              Returns 1Y
                            </p>
                            <p class="help">
                              {{ formatPercent(fund.r1yr) }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="level-item has-text-centered">
                        <div>
                          <p class="heading">
                            Match Score
                          </p>
                          <p class="help">
                            {{ fund.score }}
                          </p>
                        </div>
                      </div>
                      <div class="level-right">
                        <div class="level-item has-text-right">
                          <div>
                            <a
                              class="button is-primary is-small"
                              :href="'/ai/explore/' + fund.fund + '/?query=' + encodeURIComponent(searchText) + '&reason=' + encodeURIComponent(fund.reason)"
                            >
                              <span>Share Pick</span>
                              <span class="icon"><i class="fas fa-link fa-sm" /></span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </nav>
                  </div>
                </div>
                <p>
                  <strong>Reason</strong>
                  <br>
                  {{ fund.reason }}
                </p>
                <br>
                <p>
                  <strong>Principal Investment Strategy</strong>
                  <br>
                  {{ fund.principal_investment_strategy }}
                </p>
              </div>
            </div>
            <br>
          </div>
        </o-tab-item>
        <o-tab-item
          :value="2"
          :label="companiesLabel"
        >
          <div v-for="result in results.companies">
            <div class="message is-primary mymessage">
              <div class="message-body">
                <div class="columns">
                  <div class="column">
                    <span class="title is-5">{{ result.name }}</span>
                    <span class="heading is-size-6">{{ result.ticker }}</span>
                  </div>
                  <div class="column is-right">
                    <nav class="level">
                      <div class="level-left">
                        <div class="level-item has-text-centered">
                          <div v-if="result.fundamentals?.MarketCapitalization && result.fundamentals?.MarketCapitalization && result.fundamentals?.MarketCapitalization?.trim() != ''">
                            <p class="heading">
                              Market Cap
                            </p>
                            <p> {{ formatDollar(result.fundamentals?.MarketCapitalization) }}</p>
                          </div>
                        </div>
                        <div class="level-item has-text-centered">
                          <div v-if="result?.r1yr && result.r1yr.trim() != ''">
                            <p class="heading">
                              1 Year Return
                            </p>
                            <p>{{ formatPercent(result.r1yr) }}</p>
                          </div>
                        </div>
                        <div class="level-item has-text-centered">
                          <div v-if="result.fundamentals?.PERatio && result.fundamentals?.PeRatio?.trim() != ''">
                            <p class="heading">
                              PE Ratio
                            </p>
                            <p>{{ formatPercent(result.fundamentals?.PERatio) }}</p>
                          </div>
                        </div>
                      </div>
                      <!--
                                  <div class="level-item has-text-centered">
                                    <div>
                                            <p class="heading">P/E: {{ result.fundamentals?.PERatio }}</p>
                                            <p class="heading">Forward P/E: {{ result.fundamentals?.ForwardPERatio }}</p>
                                            <p class="heading">P/S: {{ result.fundamentals?.PriceToSalesRatioTTM }}</p>
                                            <p class="heading">Dividend Yield: {{ result.fundamentals?.DividendYield }}</p>
                                            <p class="heading">P/B: {{ result.fundamentals?.PriceToBookRatio }}</p>
                                    </div>
                                </div> -->
                      <div class="level-item has-text-centered">
                        <div>
                          <p class="heading">
                            Match Score
                          </p>
                          <p> {{ result.score }}</p>
                        </div>
                      </div>
                      <div class="level-right">
                        <div class="level-item has-text-right">
                          <div>
                            <a
                              class="button is-primary is-small"
                              :href="'/ai/explore/' + result.ticker + '/?query=' + encodeURIComponent(searchText) + '&reason=' + encodeURIComponent(result.reason || result.explanation)"
                            >
                              <span>Share Pick</span>
                              <span class="icon"><i class="fas fa-link fa-sm" /></span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </nav>
                  </div>
                </div>
                <p>
                  <strong>Reason</strong>
                  <br>
                  {{ result.explanation || result.reason }}
                </p>
                <br>
                <p>
                  <strong>Description</strong>
                  <br>
                  {{ result.description }}
                </p>
              </div>
            </div>
            <br>
          </div>
        </o-tab-item>
        <o-tab-item
          :value="3"
          :label="fundsLabel"
        >
          <div v-for="fund in results.funds">
            <div class="message is-primary mymessage">
              <div class="message-body">
                <div class="columns">
                  <div class="column">
                    <span class="title is-5">{{ fund.name }}</span>
                    <span class="heading is-size-6">{{ fund.fund }}</span>
                  </div>
                  <div class="column is-right">
                    <nav class="level">
                      <div class="level-left">
                        <!-- <div class="level-item has-text-centered">
                                            <div>
                                                <p class="heading">AUM: {{ fund.aum }}</p>
                                                <p class="heading">Expense Ratio: {{ fund.expense_ratio }}</p>
                                                <p class="heading">Front Load: {{ fund.front_load }}</p>
                                                <p class="heading">Back Load: {{ fund.back_load }}</p>
                                                <p class="heading">1 Year Return: {{ fund.r1yr }}</p>
                                            </div>
                                        </div> -->
                        <div class="level-item has-text-centered">
                          <div>
                            <p class="heading">
                              Expense Ratio
                            </p>
                            <p class="help">
                              {{ formatPercent(fund.expense_ratio) }}
                            </p>
                          </div>
                        </div>
                        <div class="level-item has-text-centered">
                          <div>
                            <p class="heading">
                              AUM
                            </p>
                            <p class="help">
                              {{ formatDollar(fund.aum) }}
                            </p>
                          </div>
                        </div>
                        <div class="level-item has-text-centered">
                          <div>
                            <p class="heading">
                              Returns 1Y
                            </p>
                            <p class="help">
                              {{ formatPercent(fund.r1yr) }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="level-item has-text-centered">
                        <div>
                          <p class="heading">
                            Match Score
                          </p>
                          <p class="help">
                            {{ fund.score }}
                          </p>
                        </div>
                      </div>
                      <div class="level-right">
                        <div class="level-item has-text-right">
                          <div>
                            <a
                              class="button is-primary is-small"
                              :href="'/ai/explore/' + fund.fund + '/?query=' + encodeURIComponent(searchText) + '&reason=' + encodeURIComponent(fund.reason)"
                            >
                              <span>Share Pick</span>
                              <span class="icon"><i class="fas fa-link fa-sm" /></span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </nav>
                  </div>
                </div>
                <p>
                  <strong>Reason</strong>
                  <br>
                  {{ fund.reason }}
                </p>
                <br>
                <p>
                  <strong>Principal Investment Strategy</strong>
                  <br>
                  {{ fund.principal_investment_strategy }}
                </p>
              </div>
            </div>
            <br>
          </div>
        </o-tab-item>
      </o-tabs>
    </div>
  </div>
</template>


<script>
import chroma from 'chroma-js';

import PieChart from '@frontend/engagebutton/js/components/subcomponents/PieChart.js';
import Collapsible from './Collapsible.vue';
export default {
  name: 'GeneratePortfolioResult',
  components: { PieChart, Collapsible },
  props: ['searchText', 'fastSearch', 'mockmode'],
  data() {
    return {
      blur: 6,
      // mock company data for placheholder stuff
      mockedDataIndex: 0,
      mockCompanyData: [
        {
          'name': 'China Marine Food Group Ltd ',
          'ticker': 'CMFO',
          'description': 'China Marine Food Group Limited, through its subsidiaries, engages in the processing, distribution, and sale of processed seafood products and algae-based beverage products primarily in the People\'s Republic of China. The company offers dried processed seafood products, such as roasted squid, roasted file fish, roasted prawns, shredded roasted squid, barbecued squid, sliced barbecued squid, sliced roasted octopus, spicy sliced octopus, spicy baby squid, spicy sliced squid, and spicy squid head products. China Marine Food Group Limited sells its dried and flavored seafood-based snack foods under the Mingxiang brand; and algae-based beverage products under the Hi-Power brand. The company also sells fresh and frozen marine catch, including Squid (Loligo bleekeri) and horse mackerel. China Marine Food Group Limited is based in Shishi, the People\'s Republic of China.',
        },
        {
          'name': 'Global Seafood Technologies Inc',
          'ticker': 'GSFD',
          'description': ' Global Seafood Technologies, Inc. engages in the processing and packaging of shrimp for seafood restaurant chains and retail grocery outlets in the United States. The company operates through the Seafood, Fishing Bait, and Freshwater Shrimp segments. The Seafood segment performs processing, packaging, and storage of shrimp and other seafood products. The company provides frozen shrimp in various sizes and descriptions, which are packaged for commercial or consumer use. Frozen, headless shrimp with shell, is the principal product processed and packaged in one-pound and two-pound packages. Peeled shrimp is also processed under private labels for customers or for distribution to restaurants, and it is used in ready-to-cook meal kits for supermarket distribution. The Fishing Bait segment packages and distributes recreational fishing bait products. Its Killer Bee Bait products include varieties of bait shrimp, catfish bait, cut squid, whole squid, cigar minnows, ballyhoo, frozen chum, and menhaden oil. Killer Bee Bait products are sold through retail outlets and at independent marinas and bait shops. The Freshwater Shrimp segment engages in the development and harvesting of farm-grown and freshwater shrimp through its hatchery and nursery facility for sale to independent aquaculture farmers. Global Seafood Technologies is based in Biloxi, Mississippi.',
        },
        {
          'name': 'Smc Entertainment Inc',
          'ticker': 'SMCE',
          'description': 'Description: SMC Entertainment, Inc. operates in the recorded music business in the United States. The company is involved in the discovery and development of artists and the related marketing, distribution, and licensing of recorded music produced by artists. It sells its products in physical form to online physical retailers; and in digital form to online digital retailers; and mobile full-track download stores. The company was formerly known as SMC Recordings, Inc. and changed its name to SMC Entertainment, Inc. in May 2011. The company is based in San Francisco, California.',
        },
        // / I aadded fictional companies but I realized this is probably a bad idea because it will make users concerned about data quality.
        {
          'name': 'ACME, Inc',
          'ticker': 'ACME',
          'description': 'ACME Corporation, operates as an all-encompassing manufacturing conglomerate producing a vast array of products. Its primary function involves creating an extensive range of goods, which often include comically hazardous or unreliable items, primarily purchased by characters like Wile E. Coyote. The company\'s operations, while frequently displayed as flawed or malfunctioning, add a distinctive humorous twist to the narrative, thereby shaping the company\'s uniquely whimsical corporate identity.',
        },
        {
          'name': 'Soylent Corp',
          'ticker': 'SYLT',
          'description': 'From an investment perspective, the Soylent Corporation, a leading food manufacturer in our dystopian reality, appears as a compelling investment given the prevailing overpopulation and resource scarcity crisis. Its high-energy food products, including the notable Soylent Green, are reportedly plankton-based, driving considerable demand due to their nutritional efficacy in a world with limited alternatives. However, recent revelations about their production - with Soylent Green shockingly discovered to be derived from human remains - have introduced significant risk and potential liabilities, urging a cautious approach to investment decisions related to this corporation.',
        },
        {
          'name': 'Anaheim Electronics',
          'ticker': 'ANHM',
          'description': 'Anaheim Electronics, a key player in the realm of mobile suit manufacturing in our current universe, has a significant influence on both civilian and military sectors. Its diversified product line spans various industries, primarily centered around the manufacturing of mobile suits for both Earth Federation Forces and Zeon remnants. However, given the volatile nature of the interstellar political climate and the implications of supplying to potential conflict instigators, investing in Anaheim Electronics would necessitate a comprehensive risk assessment of potential ramifications on both a financial and ethical level.',
        },
      ],
      mockCompanyDescriptions: [],
      searching: true,
      error: '',
      activeTab: 1,
      chartData: {
        labels: [],
        datasets: [
          {
            backgroundColor: [],
            borderWidth: 10,
            weight: .5,
            data: [],
          },
        ],
      },
      chartOptions: {
        animation: false,
      },
      explanations: [],
      funds: [],
      companies: [],
      interval: false,
      worker_id: false,
      results: {
        funds: [],
        companies: [],
      },
    };
  },
  computed: {
    companiesLabel: function() {
      if (this.companies && this.companies.length > 0) {
        return 'Companies (' + this.companies.length + ')';
      } else {
        return 'Companies';
      }
    },
    fundsLabel: function() {
      if (this.funds && this.funds.length > 0) {
        return 'Funds (' + this.funds.length + ')';
      } else {
        return 'Funds';
      }
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() { },
  created() { },
  async mounted() {
    this.blur = 4;
    const req = await fetch(
        '/ai/search_strategies',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': this.$root.$data.csrfToken,
          },
          body: JSON.stringify({ strategy: this.searchText, useInstant: this.fastSearch ? '1' : '0' }),
        },
    );
    const data = await req.json();
    if (data.result) {
      await this.setResults(data);
    } else {
      this.worker_id = data.worker_id;
      this.interval = setInterval(this.fetchResults, 1000);
    }
  },
  updated() { },
  methods: {
    formatPercent(value) {
      return (value * 100).toFixed(2) + '%'; // format as percent with 2 decimals
    },
    formatDollar(value) {
      return '$' + Math.round(value / 1000000) + 'M'; // format as dollar in millions, rounded to the nearest whole number
    },
    async fetchResults() {
      this.blur -= 1;
      this.mockedDataIndex = Math.floor(Math.random() * this.mockCompanyData.length);
      if (this.blur <= 1) {
        this.blur = 6;
      }
      this.error = '';
      const req = await fetch(
          '/ai/search_strategies_results',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRFToken': this.$root.$data.csrfToken,
            },
            body: JSON.stringify({ worker_id: this.worker_id }),
          });
      const data = await req.json();
      await this.setResults(data);
    },
    async setResults(data) {
      if (data.status == 'success') {
        this.searching = false;
        clearInterval(this.interval);
        this.interval = false;
        this.worker_id = false;
        const results = JSON.parse(data.result);
        this.results = results;

        if (results.funds || results.companies) {
          const avgScore = 50; // data.funds.map((i) => { return i.match }).reduce((a, i) => { return a + i}, 0) / data.funds.length;
          const companyIdx = 0;
          const fundIdx = 0;
          this.companies = results.companies;
          this.funds = results.funds;
          if (this.companies.length == 0 && this.funds.length == 0) {
            this.error = 'No funds or companies found';
          } else {
            this.error = '';
          }
          console.log(this.chartData);
        } else {
          this.error = 'No funds or companies found';
        }
      } else if (data.status == 'failed') {
        clearInterval(this.interval);
        this.interval = false;
        this.worker_id = false;
        alert('Error searching');
        this.error = 'Error searching';
      }
    },
    shareIdeaList() {
      const url = window.location;
      // paste the url into the clipboard
      navigator.clipboard.writeText(url).then(function() {
        alert('Idea list URL copied to clipboard');
      }, function(err) {
        alert('Error copying to clipboard');
      });
    },
  },
};
</script>


<style scoped>
.message.is-primary {
  background-color: rgba(255, 255, 255, 0.897);
}

.message.is-primary .message-body {
  color: rgba(64, 64, 64, 0.7);
}

.max-width {
  max-width: 500px;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(359deg);
  }
}

.spinning {
  width: 100px;
  animation: rotation 2s infinite linear;
}

.myImageSize {
  width: 96px;
  height: 48px;
}</style>
